import { lazy } from "react";
import AddBank from "./Bank/AddBank";
import BankLists from "./Bank/BankLists";
import EditBank from "./Bank/EditBank";
import LimitBalance from "./Credit Settings/LimitBalance";
import Markup from "./MarkUp/Markup";
import NotificationSettings from "./Notification/NotificationSettings";
import AddReq from "./Payments/AddReq";
import AllReq from "./Payments/AllReq";
import ApprovedReq from "./Payments/ApprovedReq";
import CreditTransactionHistory from "./Payments/CreditTransactionHistory";
import DeclinedReq from "./Payments/DeclinedReq";
import ManualCRDR from "./Payments/ManualCRDR";
import PendingReq from "./Payments/PendingReq";
import AccountingQueues from "./Queues/AccountingQueues";
import BusBooking from "./Queues/BusBooking";
import CabQueues from "./Queues/CabQueues";
import FlightBookingQueues from "./Queues/FlightBookingQueues";
import FlightCancellationQueues from "./Queues/FlightCancellationQueues";
import FlightHoldQueues from "./Queues/FlightHoldQueues";
import FlightRescheduleQueues from "./Queues/FlightRescheduleQueues";
import HotelBooking from "./Queues/HotelBooking";
import HotelCancellation from "./Queues/HotelCancellation";
import HotelOnRequest from "./Queues/HotelOnRequest";
import ImportPNR from "./Queues/ImportPNR";
import LccPNR from "./Queues/LccPNR";
import OfflineEstimation from "./Queues/OfflineEstimation";
import OfflineRequest from "./Queues/OfflineRequest";
import PackageBooking from "./Queues/PackageBooking";
import PackageCancellation from "./Queues/PackageCancellation";
import QueuesManagement from "./Queues/QueuesManagement";
import ReassignQueues from "./Queues/ReassignQueues";
import ToBeTicketQueues from "./Queues/ToBeTicketQueues";
import TourCancellation from "./Queues/TourCancellation";
import TrainBooking from "./Queues/TrainBooking";
import TripQueues from "./Queues/TripQueues";
import UpdatePnr from "./Queues/UpdatePnr";
import TransactionHistory from "./Transaction-history/TransactionHistory";

import AddAgentStaff from "./Users/AddAgentStaff";
import AddSubAgent from "./Users/AddSubAgent";

import PendingRequest from "./Users/PendingRequest";

import ViewAllUsers from "./Users/ViewAllUsers";

import SecurityBalance from "./Credit Settings/SecurityBalance";
import BookingHistory from "./Flight/Booking";
import CreditOpeningClosing from "./Payments/CreditOpeningClosing";

import AddCharter from "./Flight/Add";
import CharterFlightList from "./Flight/List";
import CreditBalanceSettlement from "./Payments/CreditBalanceSettlement";

import VirtualBankList from "./Bank/VirtualBankList";
import CreditLimit from "./Payments/CreditLimit";
import ApplicationSettings from "./SystemSetting/ApplicationSettings";
import BannerSetting from "./SystemSetting/BannerSetting";
import Services from "./SystemSetting/SystemSettings";

import ChangeRequest from "./Flight/ChangeRequest";

import Roles from "./Users/Roles Folder/Roles";

import Menu from "./Users/MenuFolder/Menu";
import Permission from "./Users/Permission Folder/Permission";
import AddUser from "./Users/User Folder/AddUser";
import Users from "./Users/User Folder/Users";

import CreditList from "./Credit/CreditList";
import CreditSettlement from "./Credit/CreditSettle";
import Dashboard from "./Dashboard/Dashboard";
import MemberCreditDebitList from "./Payments/MemberCreditDebit";
import AddSupplier from "./Supplier/AddSupplier";
import EditSupplier from "./Supplier/EditSupplier";
import SupplierMemberList from "./Supplier/SupplierMemberList";
import EditUser from "./Users/User Folder/EditUSer";

import AddApi from "./Api Vendor/AddApi";
import AirlinesMasterList from "./Flight/AirlinesMasterList";
import AirportsList from "./Flight/AirportsList";
import CancellationList from "./Flight/CancellationList";
import CancelRequest from "./Flight/CancelRequest";
import HotelMarkup from "./Hotel/HotelMarkup";
import AddTicket from "./OfflineTicket/AddTicket";
// import VendorList from "./Api Vendor/VendorList";
import SupplierAirlinesList from "./SupplierSetting/SupplierAirlinesList";
import SupplierCommissionList from "./SupplierSetting/SupplierCommissionList";
import SupplierList from "./SupplierSetting/SupplierList";
import GroupTagging from "./SystemSetting/GroupTagging";
import LogoUpload from "./SystemSetting/LogoUpload";
import BankDetailsUpload from "./SystemSetting/BankDetailsUpload";
import HoldBookingHistory from "./Flight/HoldBooking";
import BookedList from "./Hotel/BookedList";
import OfflineBooking from "./Hotel/OfflineBooking";
import EditCharterFlight from "./Flight/Edit";
import FlightBooking from "./CustomizeReport/FlightBooking";
import Log from "./UserActivityLog/Log";
import Report from "./SalesWishReport/Report";
import Sales from "./SalesRegion/Sales";
import Region from "./SalesRegion/Region/Region";
import Area from "./SalesRegion/Area/Area";
import RegionalManager from "./SalesRegion/RegionalManager/RegionalManager";
import SalesManager from "./SalesRegion/SalesManager/SalesManager";
import AreaSalesManager from "./SalesRegion/AreaSalesManager/AreaSalesManager";
import SeniorExecutive from "./SalesRegion/SeniorExecutive/SeniorExecutive";
import SalesPerson from "./SalesRegion/SalesPerson/SalesPerson";
import RegionalManagers from "./SalesWishReport/RegionalManagers";
import SalesManagers from "./SalesWishReport/SalesManagers";
import AreaSalesExecutive from "./SalesWishReport/AreaSalesExecutive";
import SeniorSalesExecutive from "./SalesWishReport/SeniorSalesExecutive";
import SalesPersonReport from "./SalesWishReport/SalesPerson";
import CreditLimitSettle from "./Credit/CreditLimitSettle";
import MerchantCreditTransferList from "./Credit/MerchantCreditTransferList";
// import BookingDetails from "./Flight/BookingDetails/BookingDetails";

const DistributorList = lazy(() => import("./Distributor/DistributorList"));
const AddDistributor = lazy(() => import("./Distributor/AddDistributor"));
const EditDistributor = lazy(() => import("./Distributor/EditDistributor"));
const DeleteDistributor = lazy(() => import("./Distributor/DeleteDistributor"));
const MerchantList = lazy(() => import("./Merchant/MerchantList"));
const RequestedMerchants = lazy(() => import("./Merchant/RequestedMerchants"));
const AddMerchant = lazy(() => import("./Merchant/AddMerchant"));
const EditMerchant = lazy(() => import("./Merchant/EditMerchant"));
const BookingDetails = lazy(
  () => import("./Flight/BookingDetails/BookingDetails"),
);
const EditBookingDetails = lazy(
  () => import("./Flight/BookingDetails/EditBookingDetails"),
);
const EditCancellationDetails = lazy(
  () => import("./Flight/CancellationDetails/CancellationDetails"),
);
const UserGroup = lazy(() => import("./UserGroup/UserGroup"));
const TicketBookingDetails = lazy(
  () => import("./Flight/BookingDetails/TicketDetails"),
);
const EditBookingDetailsForHotel = lazy(
  () => import("./Hotel/BookingDetails/BookingDetails"),
);
const adminRoutes = [
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
  },

  {
    path: "/admin/distributors",
    element: <DistributorList />,
  },
  {
    path: "/admin/distributor/add",
    element: <AddDistributor />,
  },
  {
    path: "/admin/distributor/edit/:memId",
    element: <EditDistributor />,
  },
  {
    path: "/admin/distributor/delete/:memId",
    element: <DeleteDistributor />,
  },
  {
    path: "/admin/merchants",
    element: <MerchantList />,
  },

  {
    path: "/admin/member-notification",
    element: <NotificationSettings />,
  },
  {
    path: "/admin/requested-merchants",
    element: <RequestedMerchants />,
  },

  {
    path: "/admin/supplier-member-list",
    element: <SupplierMemberList />,
  },
  {
    path: "/admin/supplier/add",
    element: <AddSupplier />,
  },
  {
    path: "/admin/supplier/edit/:memId",
    element: <EditSupplier />,
  },

  {
    path: "/admin/merchant/add",
    element: <AddMerchant />,
  },
  {
    path: "/admin/merchant/edit/:memId",
    element: <EditMerchant />,
  },
  {
    path: "/admin/markup",
    element: <Markup />,
  },

  {
    path: "/admin/user-group",
    element: <UserGroup />,
  },
  {
    path: "/admin/bank/bank-lists",
    element: <BankLists />,
  },
  {
    path: "/admin/bank/add",
    element: <AddBank />,
  },
  {
    path: "/transaction-history",
    element: <TransactionHistory />,
  },

  {
    path: "/admin/credit/limit-balance",
    element: <LimitBalance />,
  },
  {
    path: "/admin/credit/security-balance",
    element: <SecurityBalance />,
  },

  {
    path: "/admin/users/viewAllUsers",
    element: <ViewAllUsers />,
  },
  {
    path: "/admin/bank/editBank",
    element: <EditBank />,
  },
  {
    path: "/admin/users/addAgencyStaff",
    element: <AddAgentStaff />,
  },
  {
    path: "/admin/users/addSubagent",
    element: <AddSubAgent />,
  },
  {
    path: "/admin/users/roles",
    element: <Roles />,
  },
  {
    path: "/admin/users/users",
    element: <Users />,
  },
  {
    path: "/admin/users/add",
    element: <AddUser />,
  },
  {
    path: "/admin/users/edit",
    element: <EditUser />,
  },
  {
    path: "/admin/credit-settle",
    element: <CreditSettlement />,
  },

  {
    path: "/admin/credit-list",
    element: <CreditList />,
  },
  {
    path: "/admin/credit-limit-settlement",
    element: <CreditLimitSettle />,
  },
  {
    path: "/admin/merchant-credit-limit-settlement",
    element: <MerchantCreditTransferList />,
  },
  {
    path: "/admin/users/permission",
    element: <Permission />,
  },
  {
    path: "/admin/users/menu",
    element: <Menu />,
  },

  {
    path: "/admin/users/pendingRequest",
    element: <PendingRequest />,
  },
  {
    path: "/admin/payment/creditTransaction",
    element: <CreditTransactionHistory />,
  },
  {
    path: "/admin/payment/credit-opening-closing",
    element: <CreditOpeningClosing />,
  },
  {
    path: "/admin/payment/credit-report",
    element: <CreditLimit />,
  },
  {
    path: "/admin/payments/credit-balance-settlement",
    element: <CreditBalanceSettlement />,
  },

  {
    path: "/admin/queues/accountingQueues",
    element: <AccountingQueues />,
  },
  {
    path: "/admin/queues/importPnr",
    element: <ImportPNR />,
  },
  {
    path: "/admin/queues/lccPnr",
    element: <LccPNR />,
  },
  {
    path: "/admin/queues/queuesManagement",
    element: <QueuesManagement />,
  },
  {
    path: "/admin/queues/reassignQueues",
    element: <ReassignQueues />,
  },
  {
    path: "/admin/queues/flightBookingQueues",
    element: <FlightBookingQueues />,
  },
  {
    path: "/admin/queues/offlineRequest",
    element: <OfflineRequest />,
  },
  {
    path: "/admin/queues/toBeTicketQueues",
    element: <ToBeTicketQueues />,
  },
  {
    path: "/admin/queues/offlineEstimation",
    element: <OfflineEstimation />,
  },
  {
    path: "/admin/queues/tripQueues",
    element: <TripQueues />,
  },
  {
    path: "/admin/queues/flightCancellationQueues",
    element: <FlightCancellationQueues />,
  },
  {
    path: "/admin/queues/flightRescheduleQueues",
    element: <FlightRescheduleQueues />,
  },
  {
    path: "/admin/queues/flightHoldQueues",
    element: <FlightHoldQueues />,
  },
  {
    path: "/admin/queues/busBooking",
    element: <BusBooking />,
  },
  {
    path: "/admin/queues/trainBooking",
    element: <TrainBooking />,
  },
  {
    path: "/admin/queues/cabQueues",
    element: <CabQueues />,
  },
  {
    path: "/admin/queues/hotelBooking",
    element: <HotelBooking />,
  },
  {
    path: "/admin/queues/hotelOnRequest",
    element: <HotelOnRequest />,
  },
  {
    path: "/admin/queues/hotelCancellation",
    element: <HotelCancellation />,
  },
  {
    path: "/admin/queues/packageBooking",
    element: <PackageBooking />,
  },
  {
    path: "/admin/queues/packageCancellation",
    element: <PackageCancellation />,
  },
  {
    path: "/admin/queues/updatePnr",
    element: <UpdatePnr />,
  },
  {
    path: "/admin/queues/tourCancellation",
    element: <TourCancellation />,
  },

  {
    path: "/admin/payments/all-req",
    element: <AllReq />,
  },
  {
    path: "/admin/payments/pending-req",
    element: <PendingReq />,
  },
  {
    path: "/admin/payments/approved-req",
    element: <ApprovedReq />,
  },
  {
    path: "/admin/payments/declined-req",
    element: <DeclinedReq />,
  },
  {
    path: "/admin/payments/manual-cr-dr",
    element: <ManualCRDR />,
  },
  {
    path: "/admin/payments/add-req",
    element: <AddReq />,
  },

  {
    path: "/admin/member-credit-debit-list",
    element: <MemberCreditDebitList />,
  },

  {
    path: "/admin/flight/list",
    element: <CharterFlightList />,
  },
  {
    path: "/admin/flight/add",
    element: <AddCharter />,
  },
  {
    path: "/admin/flight/edit/:id",
    element: <EditCharterFlight />,
  },
  {
    path: "/admin/flight/change-request",
    element: <ChangeRequest />,
  },
  {
    path: "/admin/flight/booking-history",
    element: <BookingHistory />,
  },
  {
    path: "/admin/flight/hold-booking-history",
    element: <HoldBookingHistory />,
  },
  {
    path: "/admin/settings/offer-banner-setting",
    element: <BannerSetting />,
  },
  {
    path: "/admin/settings/application-setting",
    element: <ApplicationSettings />,
  },
  {
    path: "/admin/settings/services",
    element: <Services />,
  },
  {
    path: "/admin/account/virtual-bank-list",
    element: <VirtualBankList />,
  },

  {
    path: "/admin/flight/cancel-request",
    element: <CancelRequest />,
  },
  {
    path: "/admin/flight/airports-list",
    element: <AirportsList />,
  },
  {
    path: "/admin/flight/cancellation-list",
    element: <CancellationList />,
  },
  {
    path: "/admin/flight/airlines-list",
    element: <AirlinesMasterList />,
  },
  {
    path: "/admin/flight/booking-details/:id",
    element: <BookingDetails />,
  },
  {
    path: "/admin/flight/edit-booking-details/:id",
    element: <EditBookingDetails />,
  },
  {
    path: "/admin/flight/cancellation-details/:id",
    element: <EditCancellationDetails />,
  },
  {
    path: "/admin/offline/add",
    element: <AddTicket />,
  },
  {
    path: "/admin/api/add",
    element: <AddApi />,
  },
  // {
  //   path: "/admin/api-list",
  //   element: <VendorList />,
  // },
  {
    path: "/admin/flight/ticket/:id",
    element: <TicketBookingDetails />,
  },
  {
    path: "/admin/supplier/supplier-commission-list",
    element: <SupplierCommissionList />,
  },
  {
    path: "/admin/supplier/supplier-airlines-list",
    element: <SupplierAirlinesList />,
  },
  {
    path: "/admin/supplier/supplier-list",
    element: <SupplierList />,
  },
  {
    path: "/admin/supplier/group-tagged",
    element: <GroupTagging />,
  },
  // {
  //   path: "/admin/settings/login-otp-details",
  //   element: <OtpExpireSettings />,
  // },
  {
    path: "/admin/settings/company-logo-upload",
    element: <LogoUpload />,
  },
  {
    path: "/admin/settings/bank-details-upload",
    element: <BankDetailsUpload />,
  },
  {
    path: "/admin/hotel/offline-booking",
    element: <OfflineBooking />,
  },
  {
    path: "/admin/hotel/markup",
    element: <HotelMarkup />,
  },
  {
    path: "/admin/hotel/booking-history",
    element: <BookedList />,
  },
  {
    path: "/admin/hotel/booking-details/:id",
    element: <EditBookingDetailsForHotel />,
  },
  {
    path: "/admin/customize-report/flight",
    element: <FlightBooking />,
  },
  {
    path: "/admin/settings/user-activity-log",
    element: <Log />,
  },
  {
    path: "/admin/sales-report/all",
    element: <Report />,
  },
  {
    path: "/admin/sales-report/regional-managers",
    element: <RegionalManagers />,
  },
  {
    path: "/admin/sales-report/sales-managers",
    element: <SalesManagers />,
  },
  {
    path: "/admin/sales-report/area-sales-managers",
    element: <AreaSalesExecutive />,
  },
  {
    path: "/admin/sales-report/senior-executive",
    element: <SeniorSalesExecutive />,
  },
  {
    path: "/admin/sales-report/sales-person",
    element: <SalesPersonReport />,
  },
  /////
  {
    path: "/admin/account/sales-wish",
    element: <Sales />,
  },
  ////
  {
    path: "/admin/sales/region",
    element: <Region />,
  },
  {
    path: "/admin/sales/area",
    element: <Area />,
  },
  {
    path: "/admin/sales/regional-manager",
    element: <RegionalManager />,
  },
  {
    path: "/admin/sales/sales-manager",
    element: <SalesManager />,
  },
  {
    path: "/admin/sales/area-sales-manager",
    element: <AreaSalesManager />,
  },
  {
    path: "/admin/sales/senior-executive",
    element: <SeniorExecutive />,
  },
  {
    path: "/admin/sales/sales-person",
    element: <SalesPerson />,
  },
];

export default adminRoutes;
